module.exports = __webpack_public_path__ + "static/media/215.22dedd3d.webp";